<template>
  <div>
    <transition name="bottom_fade">
      <section v-show="!isScroll" class="search container fixed_bottom">
        <div class="row">
          <div class="col-9 col-sm-8 col-md-7"></div>
          <div class="col-3 col-sm-4 col-md-5 text-right">
            <div class="col-12">
              <slot name="@function"></slot>
            </div>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: "fixedBotton",
  data() {
    return {
      scrolltimeOutProcessId: "",
      isScroll: false //是否滾動
    };
  },
  created() {
    window.addEventListener("scroll", () => {
      this.scrollEvent();
    });
  },
  methods: {
    scrollEvent() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
.bottom_fade-enter-active,
.bottom_fade-leave-active {
  transition: all 0.3s ease;
}

.bottom_fade-enter,
.bottom_fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.fixed_bottom {
  z-index: 999;
  position: fixed;
  bottom: 0;
  right: 0;
  max-width: 100%;
  padding: 23px;
  background-color: #f5f5f5;
  box-shadow: rgb(158, 158, 158) 1px 3px 17px 0px;
}
</style>
